const editorNavData = [
  {
    "id": 'list-literals',
    "titleKey": "menu_list_literals",
  },
  {
    "id": 'list-images',
    "titleKey": "menu_list_images",
  },
  {
    "id": 'books',
    "titleKey": "menu_book",
  },
  {
    "id": 'logout',
    "titleKey": "menu_logout",
  }
];

export default editorNavData;